import React, { useEffect } from "react";
import { BsGoogle } from "react-icons/bs";
import { GiRabbitHead } from "react-icons/gi";
import { Link, useNavigate } from "react-router-dom";
import { useUser } from "../Contexts/UserProvider";

function GetStarted() {
  // const { user } = useUser();
  // const navigate = useNavigate();

  // useEffect(() => {
  //   if (user !== null) {
  //     navigate("/");
  //   }
  // }, []);

  return (
    <div className="p-5 min-h-screen text-neutral-400">
      <h1 className=" text-white text-3xl font-bold  flex flex-row items-center p-2 py-4">
        <GiRabbitHead size={40} />
        Todo<span className="text-green-600">Rabit</span>{" "}
      </h1>

      <div className="flex-col flex items-start justify-center my-auto">
        <h1 className="text-7xl font-bold text-white my-4">Get Started</h1>
        <p className="text-xl">
          Lorem ipsum dolor, sit amet consectetur adipisicing elit. Lorem ipsum
          dolor sit.
        </p>
        <p className="text-xl font-light">Simple ・ Powerfull ・ Sleek</p>
        <Link to="/signin">
          <button className="bg-green-700 p-2 text-white rounded-md flex  items-center space-x-2 my-4 w-full">
            <BsGoogle />
            <span>Sign In Now</span>
          </button>
        </Link>
      </div>
    </div>
  );
}

export default GetStarted;
